
































import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
// import utilService from './util.service';
import SwTable from './sw-table.vue';
import {
  TableColumnConfig,
  TableBodyMetrics,
  TableFooterConfig,
  TableData,
} from './types';

const cssPrefix = 'sw-table-footer';
const i18nPathPrefix = 'libShared.SwTable';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwTableFooter extends SwExtendedVue {
  @Prop({ type: Object, required: true })
  footerConfig: TableFooterConfig;

  @Prop({ type: Array, required: true })
  columnsConfig: TableColumnConfig[];

  @Prop({ type: Array, required: true })
  tableData: TableData;

  @Prop({ type: Object })
  effectiveInfiniteScrollConfig: SwTable['effectiveInfiniteScrollConfig'];

  @Prop({ type: String, required: true })
  theme: SwTable['theme'];

  @Prop({ type: String, required: true })
  size: SwTable['size'];

  @Prop({ type: Boolean, required: true })
  border: boolean;

  @Prop({ type: Object, required: true })
  bodyMetrics: TableBodyMetrics;

  cssPrefix = cssPrefix;
  i18nPathPrefix = i18nPathPrefix;

  /* tslint:disable-next-line */
  private render(h: CreateElement): VNode {
    let contentNode: VNode | VNode[] | null = null;

    if (!this.footerConfig.render) {
      const totalNum = !!this.effectiveInfiniteScrollConfig && this.effectiveInfiniteScrollConfig.datasetTotal !== undefined ?
        this.effectiveInfiniteScrollConfig.datasetTotal : this.tableData.length;
      contentNode = (
        <div class={[`${cssPrefix}__total-cont`, 'sw-flexbox', 'sw-flexbox--center-items']}>
          <span class={[`${cssPrefix}__total-cont__label`]}>{ this.$t(`${i18nPathPrefix}.total`) }</span>
          <span class={[`${cssPrefix}__total-cont__value`]}>{ this.$t(`${i18nPathPrefix}.items`, { totalNum }) }</span>
        </div>
      ) as VNode;
    } else {
      contentNode = this.footerConfig.render(h);
    }

    const rootNode = (
      <div class={[`${cssPrefix}`, `${cssPrefix}--${this.theme}`]}>
      {contentNode}
      </div>
    );
    return rootNode as VNode;
  }
}
